import { compose, map, pathOr } from 'ramda';

import { Condition } from '@/shared/api/protocol-ts/model/dto_report_condition_pb';

export const mapCondtitionsToTeethIDs = map<Condition, string>(
  compose(pathOr('', ['Tooth', 'ToothID'])),
);
